import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { datadogRum } from '@datadog/browser-rum';
import { default as pack } from '../package.json';

if (environment.production) {
  enableProdMode();
}

datadogRum.setGlobalContextProperty('team', environment.DATADOG_CONTEXT_TEAM);
datadogRum.setGlobalContextProperty('coststring', environment.DATADOG_CONTEXT_COSTSTRING);
datadogRum.setGlobalContextProperty('businessservice', environment.DATADOG_CONTEXT_BUSINESSSERVICE);

datadogRum.init({
  applicationId: environment.DATADOG_APPLICATION_ID,
  clientToken: environment.DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  service: environment.DATADOG_SERVICE_NAME,
  env: environment.env,
  version: pack?.version,
  sessionSampleRate: 10,
  sessionReplaySampleRate: 5,
  defaultPrivacyLevel: 'mask-user-input',
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    // Inicia o rastreamento após o aplicativo ser carregado
    datadogRum.startSessionReplayRecording();
  })
  .catch((err) => {
    console.error(err);
    // Registra erros de inicialização no Datadog
    datadogRum.addError(err);
  });
